import { Box } from "@mui/material";
import { PTTypography } from "../../../common/components/ui";

export const PageHeader = (props) => {
  const {title, description, sx} = props;
  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "20px",
      background: "#fff",
      marginBottom: "35px",
      borderRadius: "10px",
      ...sx
    }}>
      <PTTypography variant="h4">{title}</PTTypography>
      <PTTypography variant="h6">{description}</PTTypography>
    </Box>
  );
};

export default PageHeader;
